/**
 * Libellés des valeurs d'enum des actions de masse articles (GestionArticleMasse).
 * Termes d'interface fixes — les termes métier configurables restent dans labels.ts.
 */
import { ChampDefautFamille, ChampPrix, ModeAjustement, ModePartage } from './enums';
import { labels } from './labels';

export const CHAMP_DEFAUT_LABEL: Record<ChampDefautFamille, string> = {
  [ChampDefautFamille.PRIX_V]:            'Prix de vente',
  [ChampDefautFamille.PRIX_R]:            'Prix de revient',
  [ChampDefautFamille.REMISE]:            'Remise max',
  [ChampDefautFamille.TVA]:               'TVA',
  [ChampDefautFamille.UNITE]:             'Unité',
  [ChampDefautFamille.UNITE_SEC]:         'Unité secondaire',
  [ChampDefautFamille.PIECES_PAR_CARTON]: 'Pièces par carton',
  [ChampDefautFamille.TRACK_STOCK]:       'Suivi du stock',
  [ChampDefautFamille.STOCK_SECURITE]:    'Stock de sécurité',
  [ChampDefautFamille.PARTAGE]:           'Départements (partage)',
  [ChampDefautFamille.PRIX_DEPARTEMENTS]: 'Prix par département',
  [ChampDefautFamille.FOURNISSEUR]:       labels.fournisseur,
};

export const MODE_PARTAGE_LABEL: Record<ModePartage, string> = {
  [ModePartage.AJOUTER]:   'Ajouter des départements',
  [ModePartage.RETIRER]:   'Retirer des départements',
  [ModePartage.REMPLACER]: 'Remplacer la liste',
  [ModePartage.TOUS]:      'Partager avec tous',
};

export const CHAMP_LABEL: Record<ChampPrix, string> = {
  [ChampPrix.PRIX_V]: 'Prix de vente',
  [ChampPrix.PRIX_R]: 'Prix de revient',
  [ChampPrix.REMISE]: 'Remise max (%)',
};

export const MODE_LABEL: Record<ModeAjustement, string> = {
  [ModeAjustement.POURCENT]: '± Pourcentage (%)',
  [ModeAjustement.MONTANT]:  '± Montant',
  [ModeAjustement.FIXE]:     'Valeur fixe',
};
